"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useOrder = () => {
  const [order, setOrder] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    const data = JSON.parse(localStorage.getItem("mco-shop-order"));
    if ((0, _isEmpty.default)(data)) return;
    setOrder(data);
    localStorage.removeItem("mco-shop-order");
  }, []);
  return order;
};
var _default = exports.default = useOrder;